
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","viewBox":"0 0 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.83333 6.5C7.83333 5.94772 8.28105 5.5 8.83333 5.5H25.1667C25.719 5.5 26.1667 5.94772 26.1667 6.5V26.5H27.5C28.0523 26.5 28.5 26.9477 28.5 27.5C28.5 28.0523 28.0523 28.5 27.5 28.5H25.1667H19.3333H14.6667H8.83333H6.5C5.94772 28.5 5.5 28.0523 5.5 27.5C5.5 26.9477 5.94772 26.5 6.5 26.5H7.83333V6.5ZM15.6667 26.5H18.3333V21.5H15.6667V26.5ZM20.3333 26.5V20.5C20.3333 19.9477 19.8856 19.5 19.3333 19.5H14.6667C14.1144 19.5 13.6667 19.9477 13.6667 20.5V26.5H9.83333V7.5H24.1667V26.5H20.3333ZM12.5 11.1667C12.5 10.6144 12.9477 10.1667 13.5 10.1667H14.6667C15.219 10.1667 15.6667 10.6144 15.6667 11.1667C15.6667 11.719 15.219 12.1667 14.6667 12.1667H13.5C12.9477 12.1667 12.5 11.719 12.5 11.1667ZM19.3333 10.1667C18.781 10.1667 18.3333 10.6144 18.3333 11.1667C18.3333 11.719 18.781 12.1667 19.3333 12.1667H20.5C21.0523 12.1667 21.5 11.719 21.5 11.1667C21.5 10.6144 21.0523 10.1667 20.5 10.1667H19.3333ZM18.3333 15.8333C18.3333 15.281 18.781 14.8333 19.3333 14.8333H20.5C21.0523 14.8333 21.5 15.281 21.5 15.8333C21.5 16.3856 21.0523 16.8333 20.5 16.8333H19.3333C18.781 16.8333 18.3333 16.3856 18.3333 15.8333ZM13.5 14.8333C12.9477 14.8333 12.5 15.281 12.5 15.8333C12.5 16.3856 12.9477 16.8333 13.5 16.8333H14.6667C15.219 16.8333 15.6667 16.3856 15.6667 15.8333C15.6667 15.281 15.219 14.8333 14.6667 14.8333H13.5Z","fill":"currentColor"}})])
          )
        }
      }
    